/** Temperature units the weather tools accept and show. */
export type TemperatureUnit = "C" | "F" | "K";

export const ABSOLUTE_ZERO_C = -273.15;

export function toCelsius(value: number, unit: TemperatureUnit): number {
  if (unit === "F") {
    return ((value - 32) * 5) / 9;
  }
  if (unit === "K") {
    return value + ABSOLUTE_ZERO_C;
  }
  return value;
}

export function fromCelsius(celsius: number, unit: TemperatureUnit): number {
  if (unit === "F") {
    return (celsius * 9) / 5 + 32;
  }
  if (unit === "K") {
    return celsius - ABSOLUTE_ZERO_C;
  }
  return celsius;
}

/** A temperature *difference* (a spread, not a reading) between units. */
export function differenceFromCelsius(
  delta: number,
  unit: TemperatureUnit
): number {
  return unit === "F" ? (delta * 9) / 5 : delta;
}

/** The unit's symbol as written after a number: °C, °F, K. */
export function unitSymbol(unit: TemperatureUnit): string {
  return unit === "K" ? "K" : `°${unit}`;
}
